import gql from "graphql-tag";

const REQUEST_CONTRIBUTION_REFUND_GQL = gql`
  mutation requestContributionRefund($investmentId: String!) {
    requestContributionRefund(
      requestContributionRefundInput: { investmentId: $investmentId }
    ) {
      status
      requestedDate
      refundedDate
    }
  }
`;

export default REQUEST_CONTRIBUTION_REFUND_GQL;
